export type Room = {
	title: { [lang: string]: string };
	image: string;
	url: string;
	price: number;
};

export const rooms: { [key: string]: Room } = {
	"standard2": {
		title: {
			sk: '2-lôžková izba Štandard',
			en: 'Standard Double Room'
		},
		image: 'izby/izba-standard-2lozkova.jpg',
		url: '2-lozkova-izba-standard',
		price: 90,
	},
	"standard3": {
		title: {
			sk: '3-lôžková izba Štandard',
			en: 'Standard Triple Room',
		},
		image: 'izby/izba-standard-2lozkova.jpg',
		url: '3-lozkova-izba-standard',
		price: 130,
	},
	"premium": {
		title: {
			sk: 'Izba Premium',
			en: 'Premium Room'
		},
		image: 'izby/izba-premium.jpg',
		url: '3-lozkova-izba-standard',
		price: 140,
	},
	"family": {
		title: {
			sk: 'Rodinný apartmán',
			en: 'Family Apartment'
		},
		image: 'izby/apartman-rodinny.jpg',
		url: 'rodinny-apartman',
		price: 160,
	},
	"komfort": {
		title: {
			sk: 'Apartmán Komfort',
			en: 'Comfort Apartment'
		},
		image: 'izby/apartman-komfort.jpg',
		url: 'apartman-komfort',
		price: 160,
	},
	"bezbarier": {
		title: {
			sk: 'Bezbarierová izba Premium',
			en: 'Accessible Premium Room'
		},
		image: 'izby/izba-premium-3.jpg',
		url: 'izba-premium',
		price: 140,
	},
};
